<template>
  <!--product body-->
  <div class="phone">
    <p>24小时咨询服务电话</p>
    <b>18916006004</b>
  </div>
</template>

<script>
export default {
  name: 'Contract',
  components: {},
  data() {
    return {
      description: '联系方式组件',
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
